import { isGspChannelSessionActiveForProduct } from '@theme/gsp-channel-session';

/** Refresh product-scoped price visibility without granting sessions to other products. */
function refresh() {
  try {
    /** @type {any} */ (window).GSP_CHANNEL_REFRESH?.();
    for (const input of document.querySelectorAll('input[data-gsp-line-item-discount]')) {
      if (input instanceof HTMLInputElement) {
        input.disabled = !isGspChannelSessionActiveForProduct(input.dataset.gspProductId);
      }
    }
  } catch {
    // Storage may be unavailable in restricted browsing contexts.
  }
}
refresh();
document.addEventListener('DOMContentLoaded', refresh);
document.addEventListener('shopify:section:load', refresh);
window.addEventListener('pageshow', refresh);
document.addEventListener('visibilitychange', refresh);
// Expire displayed prices on long-lived pages as well as on navigation.
setInterval(refresh, 60000);
